module.exports = __webpack_public_path__ + "static/img/colck.d85e7f9.1763978124417.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cartimg/colck.png
// module id = ztzn
// module chunks = 69